const hexToRgb = (hex) => {
  let r = 0,
    g = 0,
    b = 0;
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex.length === 7) {
    r = parseInt(hex.substring(1, 3), 16);
    g = parseInt(hex.substring(3, 5), 16);
    b = parseInt(hex.substring(5, 7), 16);
  }
  return [r, g, b];
};

const rgbToHex = (r, g, b) => {
  r = Math.round(Math.max(0, Math.min(255, r)));
  g = Math.round(Math.max(0, Math.min(255, g)));
  b = Math.round(Math.max(0, Math.min(255, b)));
  return (
    '#' +
    ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()
  );
};

const interpolateColor = (color1, color2, percentage) => {
  percentage = Math.max(0, Math.min(1, percentage));
  const rgb1 = hexToRgb(color1);
  const rgb2 = hexToRgb(color2);
  const r = rgb1[0] + (rgb2[0] - rgb1[0]) * percentage;
  const g = rgb1[1] + (rgb2[1] - rgb1[1]) * percentage;
  const b = rgb1[2] + (rgb2[2] - rgb1[2]) * percentage;
  return rgbToHex(r, g, b);
};

const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent);

export { hexToRgb, rgbToHex, interpolateColor, isMobileDevice };
